export default {
    id: 'green-blue',
    colors: ['#A5ED8E', '#0044A3'],
};
